<template>
  <v-container>
    <v-card>
      <v-card-title>Mister Paradise Jeep Reservation</v-card-title>
      <v-card-text>
        <v-form ref="form1">
          <v-text-field :rules="[stdRules.required]" v-model="userdata.fullName" label="Full Name"></v-text-field>
          <v-text-field label="Email" :rules="stdRules.email" v-model="userdata.email" validate-on-blur></v-text-field>
          <v-select label="Prefered car" return-object v-model="userdata.pc" item-text="name" item-value="name"
            :items="carnames"></v-select>
          <v-row>
            <v-col md='4'>
              <v-card class='pl-4'>
                <v-card-title>Pickup date</v-card-title>
                <v-date-picker v-model="userdata.pickupDate" :min="today" class='mr-2 mb-3'></v-date-picker>
                <div v-if="pickupErrorMsg" class='sm-12 error--text'>{{ pickupErrorMsg }}</div>
                <v-select :rules="[stdRules.required]" :items="times" label='Pickup time'
                  v-model="userdata.pickupTime"></v-select>
                <v-select v-model="userdata.pickupLocation" :items="locations" label="Pickup location" item-text="name"
                  item-value="name" return-object :rules="[stdRules.objRequired]">
                  <!-- Template for render data when the select is expanded -->
                  <template slot="item" slot-scope="data">
                    <!-- Divider and Header-->
                    <template v-if="typeof data.item !== 'object'">
                      <span class='display-2'>{{ data.item }}</span>
                      <!--<v-list-tile-content v-text=""/>-->
                    </template>
                    <!-- Normal item -->
                    <template v-else>
                      {{ data.item.name }}
                    </template>
                  </template>
                </v-select>
                <v-text-field v-if="pickupSpecify" v-model="userdata.pickupLocationCustom" label="Other location"
                  :rules="[stdRules.required]">
                </v-text-field>
                <v-text-field v-if="pickupHato" v-model="userdata.pickupFlightNumber" label="Flight numbe if you have it">
                </v-text-field>
              </v-card>
            </v-col>
            <v-col md='4'>
              <v-card class='pl-4'>
                <v-card-title>Dropoff date</v-card-title>
                <v-card-subtitle class='red--text' v-if="invalidDropoff">Please select dropoff date (min rental period 2
                  days)</v-card-subtitle>
                <v-date-picker color="green" v-model="userdata.dropoffDate" :min="twodaysMore" class='mb-3'
                  ref="dropoffDatePicker" :rules="[stdRules.required]"></v-date-picker>
                <div v-if="dropoffErrorMsg" class='sm-12 error--text'>{{ dropoffErrorMsg }}</div>
                <v-select :items="times" :rules="[stdRules.required]" label='Dropoff time'
                  v-model="userdata.dropoffTime"></v-select>

                <v-select v-model="userdata.dropoffLocation" :items="locations" label="Dropoff location" item-text="name"
                  item-value="name" return-object :rules="[stdRules.objRequired]">
                  <!-- Template for render data when the select is expanded -->
                  <template slot="item" slot-scope="data">
                    <!-- Divider and Header-->
                    <template v-if="typeof data.item !== 'object'">
                      <span class='display-2'>{{ data.item }}</span>
                      <!--<v-list-tile-content v-text=""/>-->
                    </template>
                    <!-- Normal item -->
                    <template v-else>
                      {{ data.item.name }}
                    </template>
                  </template>
                </v-select>
                <v-text-field v-if="dropoffSpecify" v-model="userdata.dropoffLocationCustom" label="Other location"
                  :rules="[stdRules.required]">
                </v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <v-select :items="depositType" label="deposit" v-model="userdata.deposit"></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color='blue' @click="proceed()">Proceed</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showDialog" width="50%">
      <v-card>
        <v-card-title>We need a little bit more info</v-card-title>
        <v-card-text>Please check the form and try again</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import GlobalHelper from "../mixins/GlobalHelper"

export default {
  name: 'Reservations',
  mixins: [GlobalHelper],
  data: () => ({
    dropoffErrorMsg: "",
    pickupErrorMsg: "",
    status: 0,
    showDialog: "",
    stdRules: {
      required: v => v.length > 0 || "This field is required",
      objRequired: v => typeof v == 'object' || "this field is required",
      email: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      notneg: v => parseInt(v) > 0 || "This field is required"
    }
  }),
  mounted() {
    this.userdata.pc = this.$route.query.pc
    //let data = "{\"name\":\"ingmar\",\"lastname\":\"schnitzler\"}"
    //this.userdata = this.$cookies.get('reservation')
    //console.log(this.userdata)
  },
  methods: {
    proceed() {
      let dateError = false
      if (!this.userdata.pc || !this.userdata.pc.value) {
          this.userdata.pc = this.carnames[this.carnames.length - 1];
      }
      if (this.userdata.pickupDate == "") {
        this.pickupErrorMsg = "Please select pickup date"
        dateError = true
      } else {
        this.pickupErrorMsg = ""
      }
      if (this.userdata.dropoffDate == "") {
        this.dropoffErrorMsg = "Please select dropoff date"
        dateError = true
      } else {
        this.dropoffErrorMsg = ""
      }
      if (dateError) {
        this.showDialog = true
      }
      if (!this.$refs.form1.validate()) {
        this.showDialog = true
      } else {
        if (dateError) {
          return
        }
        this.$store.commit("setUserData", this.userdata)
        let data = {
          ...this.$store.state.userData,
          action: "prebook"
        }
        this.$store.commit("setStatus", 1)
        this.sendToServer(data)
      }
    }
  },
  created() {
    if (this.$store.state.userData) {
      this.userdata = this.$store.state.userData
    }
  },
  computed: {
    pickupSpecify() {
      if (!this.userdata.pickupLocation) {
        return false
      }
      if (this.userdata.pickupLocation.name == "Please specify") {
        return true
      }
      return false
    },
    dropoffSpecify() {
      if (!this.userdata.dropoffLocation) {
        return false
      }
      if (this.userdata.dropoffLocation.name == "Please specify") {
        return true
      }
      return false
    },
    pickupHato() {
      if (!this.userdata.pickupLocation) {
        return false
      }
      if (this.userdata.pickupLocation.name == "Hato Airport") {
        return true
      }
      return false
    },
    today() {
      return new Date().toISOString().slice(0, 10)
    },
    times() {
      let a = []
      for (let i = 9; i < 20; i++) {
        a.push(`${i}:00`)
      }
      return a
    },
    twodaysMore() {
      return this.$moment(this.userdata.pickupDate).add(2, 'day').format("YYYY-MM-DD")
    },
    invalidDropoff() {
      if (!this.userdata.dropoffDate) {
        return false
      }
      return !this.$moment(this.userdata.pickupDate).add(2, 'day').isSameOrBefore(this.userdata.dropoffDate)
    }
  },
  watch: {
    "userdata.pickupDate"() {
      if (this.invalidDropoff) {
        this.userdata.dropoffDate = ""
      }
    }
  }
}
</script>
